<template>
  <div :id="asin" class="card">
    <div class="card-image">
      <a :href="shortLink" target="new">
        <figure class="image is-128x128">
          <img :src="imgLink.URL" alt="" />
        </figure>
      </a>
    </div>
    <div class="card-content">
      <div class="media">
        <div class="media-content">
          <p class="title is-6">
            <a
              v-line-clamp:25="2"
              :href="shortLink"
              class="product-title"
              target="new"
              >{{ title }}</a
            >
          </p>
        </div>
      </div>
      <div class="content">
        <div class="product-price">
          <div v-if="currentPrice">{{ currentPrice }}</div>
          <a v-else :href="shortLink" target="new"
            ><span class="tag is-primary">See Price</span></a
          >
        </div>
        <span v-line-clamp:25="3" v-if="formattedDescription"
          >{{ formattedDescription }}
        </span>
        <a v-else :href="shortLink" target="new">Read More.</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductTile',
  props: {
    asin: {
      type: String,
      required: true
    },
    itemAttributes: {
      type: null,
      required: false,
      default: {}
    },
    itemOffers: {
      type: null,
      required: false,
      default: {}
    },
    title: {
      type: String,
      required: true
    },
    description: {
      type: null,
      required: false,
      default: ''
    },
    shortLink: {
      type: String,
      required: true
    },
    imgLink: {
      type: null,
      required: false,
      default: () => ({ URL: require('@/assets/chinchilla_contact.jpeg') })
    }
  },
  computed: {
    formattedDescription() {
      const { EditorialReview: { Content = '' } = {} } = this.description
      return this.$options.filters.stripHTML(Content)
    },
    currentPrice() {
      const {
        ListPrice: { FormattedPrice: OriginalPrice } = {}
      } = this.itemAttributes
      const {
        Offer: {
          OfferListing: {
            Price: { Amount, FormattedPrice: NewPrice } = {}
          } = {}
        } = {}
      } = this.itemOffers

      return (Amount ? NewPrice : OriginalPrice) || ''
    }
  }
}
</script>

<style lang="scss">
.product-title {
  line-height: initial;
}

.product-price {
  color: #d0011b;
  font-weight: bold;
  min-height: 28px;
}

.card {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 20px 0px 5px 0px;
  border-radius: 10px;

  figure {
    display: flex;
    align-items: center;
    margin: 0 auto !important;

    &.image img {
      max-height: 100%;
      width: auto;
      margin: 0 auto;
      border: none;
    }
  }

  .card-footer {
    margin-top: auto;
  }
}
</style>
